import { createFileRoute } from '@tanstack/react-router';
import { parseTraceSearch, type TraceSearch } from '@/features/stock/lots-search';
import { LotTracePage } from '@/features/stock/lot-trace-page';

export const Route = createFileRoute('/_app/stock/lots/$lotNo')({
  // ?node= is the selected node and ?dir= the direction the chain is read in, so a
  // shared link opens on the same node (§4.8); ?edit=1 opens lot maintenance
  validateSearch: (s: Record<string, unknown>): TraceSearch => parseTraceSearch(s),
  component: function LotTrace() {
    return <LotTracePage lotNo={Route.useParams().lotNo} search={Route.useSearch()} />;
  },
});
